import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const HomeFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M19.64 9.08 14 4.03c-1.16-1.04-2.85-1.03-4.01 0L4.34 9.11c-.69.62-1.09 1.54-1.09 2.5v5.84c0 1.81 1.39 3.28 3.1 3.28h11.29c1.71 0 3.1-1.47 3.1-3.28v-5.88c0-.97-.4-1.88-1.1-2.5v.01Zm-4.5 8.54H8.85a.76.76 0 1 1 0-1.52h6.29a.76.76 0 1 1 0 1.52Z"
      fill={color}
    />
  </Svg>
)

export default HomeFilled
